import _ from 'lodash';

const postFormSettings = {
  form: 'post',
  fields: ['title', 'content', 'categoryId', 'ownerId'],
  validate: values => {
    const errors = {};
    const { content, title } = values;

    if (!_.trim(title)) {
      errors.title = 'required';
    }

    if (content) {
      if (content.blocks.length < 2 && !content.blocks[0].text.length) {
        errors.content = 'required';
      } else {
        const entityMap = content.entityMap;
        Object.keys(content.entityMap).forEach(key => {
          if (entityMap[key].data.isLoading) {
            errors.content = 'uploading';
          }
        });
      }
    }

    return errors;
  },
};

export default postFormSettings;



// WEBPACK FOOTER //
// ./app/services/post-form-settings.js